/**
 * Angular adapter factory for GeoCode4
 */
angular.module('checkout').service(
    'geoCode3Stripped',
    [
        '$http',
        function ($http) {
            return {
                /**
                 *
                 * @param {object} filterParams object like:
                 * {
                 *       'filter[where][zip]': address['postalCode'],
                 *      'filter[where][city]': address['city'],   //optional
                 *      'filter[where][state]': address['state']  //optional
                 *  }
                 * @returns {Promise.<T>|*|Promise}
                 */
                getGeoCodes: function (filterParams) {
                    return $http(
                        {
                            method: 'GET',
                            url: '/api/resource/geo-code',
                            params: filterParams,
                        }
                    );
                },
            };
        },
    ]
);
